import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, ToggleButton } from "react-bootstrap";
import {
  MdGridView,
  MdLocationOn,
  MdOutlineCancel,
  MdOutlineFormatListBulleted,
  MdOutlineSearch,
} from "react-icons/md";
import { RiComputerLine } from "react-icons/ri";
import { FaMapMarkedAlt, FaTag } from "react-icons/fa";
import { RiCheckboxMultipleBlankLine, RiCheckboxMultipleLine } from "react-icons/ri";
import { BsCalendar2Week, BsCalendarPlus } from "react-icons/bs";
import { GrGroup } from "react-icons/gr";
import { useSelector } from "react-redux";
import { apiGetLocalisations } from "../../../api/ApiLocalisation";
import { apiGetUsages } from "../../../api/ApiUsage";
import { usagesDigital } from "../../../constants/usagesDigital";
import { useLocation } from "react-router-dom";
import MapGoogle from "../localisation/MapGoogle";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const BlocFiltresEspaces = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const {
    spaces,
    setFilterSpaces,
    setFiltreUsagesActif,
    setFiltreUsagesDigitalActif,
    infoView,
    setInfoView,
  } = props;

  const [showLocalisation, setShowLocalisation] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showCapacity, setShowCapacity] = useState(false);
  const [showUsages, setShowUsages] = useState(false);
  const [showUsagesDigitaux, setShowUsagesDigitaux] = useState(false);

  const [localisationFilter, setLocalisationFilter] = useState([]);
  const [usageDigitalFilter, setUsageDigitalFilter] = useState([]);
  const [capacityFilter, setCapacityFilter] = useState(["1-5", "5-10", "10-20", "20-all"]);
  const [usageFilter, setUsageFilter] = useState([]);

  const [query, setQuery] = useState("");
  const [localisationSelected, setLocalisationSelected] = useState("");
  const [usageDigitalSelected, setUsageDigitalSelected] = useState([]);
  const [usageSelected, setUsageSelected] = useState([]);
  const [capacitySelected, setCapacitySelected] = useState(["1-5", "5-10", "10-20", "20-all"]);
  const [calendrierSelected, setCalendrierSelected] = useState(checkUrl());

  const [filtresAllumes, setFiltresAllumes] = useState([]);

  let queryParams = useQuery();

  /* permet de ne pas mettre de filtres si une demande de popup in URL a été faite */
  function checkUrl() {
    if (window.location.search || !ReduxInstance.calendrier) {
      return false;
    }
    return true;
  }

  const recupLocalisations = async () => {
    const res = await apiGetLocalisations(ReduxInstance._id);
    if (res.data) {
      setLocalisationFilter(res.data);

      if (queryParams.get("localisation")) {
        setLocalisationSelected(queryParams.get("localisation"));
        setShowLocalisation(true);
      }
    }
  };

  const recupUsagesDigitaux = () => {
    setUsageDigitalFilter(usagesDigital);
    setUsageDigitalSelected(usagesDigital);
  };

  const recupUsages = async () => {
    const resUsages = await apiGetUsages(ReduxInstance._id);
    setUsageFilter(resUsages.data);
    setUsageSelected(resUsages.data);
  };

  const toggleUsageDigitaux = (usage) => {
    if (usageDigitalSelected.filter((item) => item.tag === usage.value).length) {
      setUsageDigitalSelected(usageDigitalSelected.filter((item) => item.tag !== usage.value));
    } else {
      let newUsageDigitalSelected = [...usageDigitalSelected];
      let rajoutUsage = usageDigitalFilter.filter((item) => item.tag === usage.value);
      newUsageDigitalSelected.push(rajoutUsage[0]);
      setUsageDigitalSelected(newUsageDigitalSelected);
    }
  };

  const toggleUsage = (usage) => {
    if (usageSelected.filter((item) => item._id === usage.value).length) {
      setUsageSelected(usageSelected.filter((item) => item._id !== usage.value));
    } else {
      let newUsageSelected = [...usageSelected];
      let rajoutUsage = usageFilter.filter((item) => item._id === usage.value);
      newUsageSelected.push(rajoutUsage[0]);
      setUsageSelected(newUsageSelected);
    }
  };

  const toggleCapacity = (capacity) => {
    if (capacitySelected.filter((item) => item === capacity.value).length) {
      setCapacitySelected(capacitySelected.filter((item) => item !== capacity.value));
    } else {
      let newCapacitySelected = [...capacitySelected];
      let rajoutCapacity = capacityFilter.filter((item) => item === capacity.value);
      newCapacitySelected.push(rajoutCapacity[0]);
      setCapacitySelected(newCapacitySelected);
    }
  };

  const filterSpacesByLocalisation = (spaces, localisation) => {
    return spaces.filter((space) => space.localisation._id === localisation);
  };

  const filterSpacesByUsageDigital = (spaces, usages) => {
    let newSpaces = [];

    spaces.map((space, index) => {
      if (space.mainUseDigital || space.secondaryUsesDigital.length) {
        if (space.mainUseDigital) {
          if (usages.filter((item) => item.tag === space.mainUseDigital).length) {
            newSpaces.push(space);
            return false;
          }
        }

        if (space.secondaryUsesDigital.length) {
          if (usages.filter((item) => space.secondaryUsesDigital.includes(item.tag)).length) {
            newSpaces.push(space);
            return false;
          }
        }
      } else {
        // si la salle n'a pas d'usage affecté et qu'il n'y a pas de filtres de recherche particulier sur les usages alors on montre aussi ceux qui ont MainUse === null
        if (usages.length === usageDigitalFilter.length) newSpaces.push(space);
      }
      return false;
    });
    return newSpaces;
  };

  const filterSpacesByUsage = (spaces, usages) => {
    let newSpaces = [];
    spaces.map((space, index) => {
      if (space.usages && space.usages.length) {
        if (usages.filter((item) => space.usages.includes(item._id)).length) {
          newSpaces.push(space);
          return false;
        }
      } else {
        // si la salle n'a pas d'usage affecté et qu'il n'y a pas de filtres de recherche particulier sur les usages alors on montre aussi ceux qui ont MainUse === null
        if (usages.length === usageFilter.length) newSpaces.push(space);
      }
      return false;
    });
    return newSpaces;
  };

  const filterSpacesByCapacity = (spaces, capacities) => {
    let newSpaces = [];

    spaces.map((space, index) => {
      if (space.capacite) {
        capacitySelected.map((capaciteCochee) => {
          switch (capaciteCochee) {
            case "1-5":
              if (space.capacite <= 5) {
                newSpaces.push(space);
              }
              break;
            case "5-10":
              if (space.capacite > 5 && space.capacite <= 10) {
                newSpaces.push(space);
              }
              break;
            case "10-20":
              if (space.capacite > 10 && space.capacite <= 20) {
                newSpaces.push(space);
              }
              break;
            case "20-all":
              if (space.capacite > 20) {
                newSpaces.push(space);
              }
              break;
            default:
              return false;
          }
        });
      } else {
        if (capacities.length === capacityFilter.length) {
          newSpaces.push(space);
          return false;
        }
      }
      return false;
    });

    return newSpaces;
  };

  const filterSpacesByQuery = (espace, query) => {
    const searchString = query.toUpperCase();
    const regex = new RegExp(searchString);
    return espace.filter((space) => {
      const spaceNom = space.nom.toUpperCase();
      /* si on trouve la recherche peu importe ou dans le nom / if (spaceNom.search(regex) === 0) pour chercher au debut du nom*/
      if (spaceNom.search(regex) > -1) {
        return true;
      }
      return false;
    });
  };

  const InfosTiersLieu = () => {
    const localisation = localisationFilter.filter((item) => item._id === localisationSelected);

    if (localisation.length === 1) {
      return (
        <div className="d-flex ms-2">
          <div
            className="mt-1 me-2"
            id="toggleGoogleMap"
            onClick={(e) => {
              document.getElementById("MapGoogle").style.display = "block";
              document.getElementById("toggleGoogleMap").style.display = "none";
            }}
          >
            <FaMapMarkedAlt size="2em" role="button" />
          </div>
          <div>
            <div>
              <h1>{localisation[0].nom}</h1>
            </div>
            <div>{localisation[0].adresse}</div>
            <div> {localisation[0].pays}</div>
          </div>
        </div>
      );
    }

    return <></>;
  };

  const toggleBoutonsFiltresEspaces = () => {
    let filtresAllumesPreparation = [];

    /* calendrier selectionne  */
    if (calendrierSelected) filtresAllumesPreparation.push("calendrier");

    /* localisation selectionnee */
    if (localisationSelected !== "") filtresAllumesPreparation.push("localisation");

    /* au moins une case usages n'a pas été cochée */
    if (usageSelected.length !== usageFilter.length) filtresAllumesPreparation.push("usages");

    /* au moins une case usages digitaux n'a pas été cochée */
    if (usageDigitalSelected.length !== usageDigitalFilter.length)
      filtresAllumesPreparation.push("usagesDigitaux");

    /* au moins une capacite n'a pas ete cochee */
    if (capacitySelected.length !== capacityFilter.length)
      filtresAllumesPreparation.push("capacite");

    setFiltresAllumes(filtresAllumesPreparation);
  };

  const cancelFiltres = () => {
    setShowSearch(false);
    setQuery("");
    setShowLocalisation(false);
    setShowUsages(false);
    setShowUsagesDigitaux(false);
    setCapacitySelected(capacityFilter);
    setLocalisationSelected("");
    setUsageDigitalSelected(usageDigitalFilter);
    setUsageSelected(usageFilter);
    setCalendrierSelected(false);
  };

  useEffect(() => {
    recupLocalisations();
    recupUsagesDigitaux();
    recupUsages();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    /* on recopie le tableau d'origine */
    let spacesCopy = spaces;

    /* moteur de recherche */
    if (query) {
      spacesCopy = filterSpacesByQuery(spacesCopy, query);
    }

    /* si on demande le calendrier alors on affiche que les salles avec calendriers */
    if (calendrierSelected) {
      spacesCopy = spacesCopy.filter((item) => item.email);
    }

    /* on applique le filtre usages si renseigné */
    if (usageDigitalSelected && usageDigitalFilter.length > 0) {
      spacesCopy = filterSpacesByUsageDigital(spacesCopy, usageDigitalSelected);
    }

    if (usageSelected && usageFilter.length > 0) {
      spacesCopy = filterSpacesByUsage(spacesCopy, usageSelected);
    }

    if (usageDigitalSelected.length !== usageDigitalFilter.length) {
      setFiltreUsagesDigitalActif(true);
    } else {
      setFiltreUsagesDigitalActif(false);
    }

    if (usageSelected.length !== usageFilter.length) {
      setFiltreUsagesActif(true);
    } else {
      setFiltreUsagesActif(false);
    }

    /* on applique le filtre localisation si renseigné */
    if (localisationSelected && localisationFilter.length > 0) {
      spacesCopy = filterSpacesByLocalisation(spacesCopy, localisationSelected);
    }

    if (capacitySelected && capacityFilter.length > 0) {
      spacesCopy = filterSpacesByCapacity(spacesCopy, capacitySelected);
    }

    /* permet de mettre en jaune les filtres actifs (ceux ou l'on a dcoche des cases par exemple) */
    toggleBoutonsFiltresEspaces();

    setFilterSpaces(spacesCopy);
  }, [
    spaces,
    localisationSelected,
    usageDigitalSelected,
    usageSelected,
    capacitySelected,
    query,
    calendrierSelected,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="d-flex mb-3 justify-content-left  flex-wrap">
        <div className="blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          <ToggleButton
            size="sm"
            id="toggle-check-info"
            type="checkbox"
            variant=""
            checked={infoView}
            value="1"
            onChange={(e) => setInfoView(e.currentTarget.checked)}
          >
            {!infoView ? <MdGridView size="2em" /> : <MdOutlineFormatListBulleted size="2em" />}
          </ToggleButton>
        </div>
        <div
          className={
            filtresAllumes.includes("localisation")
              ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
              : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
          }
        >
          <MdLocationOn
            size="1.5em"
            onClick={(e) => {
              setShowLocalisation(!showLocalisation);
              setShowUsagesDigitaux(false);
              setShowUsages(false);
              setShowSearch(true);
              setShowCapacity(false);
            }}
            role="button"
          />
        </div>
        {usageFilter.length > 0 && (
          <div
            className={
              filtresAllumes.includes("usages")
                ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
                : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
            }
          >
            <FaTag
              size="1.2em"
              onClick={(e) => {
                setShowUsagesDigitaux(false);
                setShowUsages(!showUsages);
                setShowLocalisation(false);
                setShowSearch(true);
                setShowCapacity(false);
              }}
              role="button"
            />
          </div>
        )}
        <div
          className={
            filtresAllumes.includes("usagesDigitaux")
              ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
              : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
          }
        >
          <RiComputerLine
            size="1.5em"
            onClick={(e) => {
              setShowUsagesDigitaux(!showUsagesDigitaux);
              setShowUsages(false);
              setShowLocalisation(false);
              setShowSearch(true);
              setShowCapacity(false);
            }}
            role="button"
          />
        </div>
        <div
          className={
            filtresAllumes.includes("capacite")
              ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
              : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
          }
        >
          <GrGroup
            size="1.5em"
            onClick={(e) => {
              setShowCapacity(!showCapacity);
              setShowUsagesDigitaux(false);
              setShowUsages(false);
              setShowLocalisation(false);
              setShowSearch(true);
            }}
            role="button"
          />
        </div>
        {ReduxInstance.calendrier && (
          <div
            className={
              filtresAllumes.includes("calendrier")
                ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
                : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
            }
          >
            <BsCalendar2Week
              size="1.5em"
              role="button"
              onClick={(e) => {
                setShowCapacity(false);
                setShowUsagesDigitaux(false);
                setShowUsages(false);
                setShowLocalisation(false);
                setShowSearch(true);
                setCalendrierSelected(!calendrierSelected);
              }}
            />
          </div>
        )}
        <div className="blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          <MdOutlineSearch
            size="2em"
            onClick={(e) => {
              setShowSearch(true);
              setShowUsagesDigitaux(false);
              setShowUsages(false);
              setShowLocalisation(false);
              setShowCapacity(false);
            }}
            role="button"
          />

          {showSearch && (
            <Form.Control
              type="text"
              name="nom"
              placeholder={t("commun.form.placeholder.rechercheEspaces")}
              value={query}
              className="border-0 "
              onChange={(e) => setQuery(e.target.value)}
            />
          )}
        </div>

        {(localisationSelected ||
          usageSelected.length !== usageFilter.length ||
          usageDigitalSelected.length !== usageDigitalFilter.length ||
          capacitySelected.length !== capacityFilter.length ||
          query ||
          calendrierSelected) && (
          <div className="d-flex m-2 align-items-center  ">
            <MdOutlineCancel
              size="1.5em"
              role="button"
              onClick={() => cancelFiltres("")}
              className="ms-2 text-danger"
            />
          </div>
        )}
      </div>
      {showLocalisation && (
        <div className="d-flex  flex-wrap border-bottom pb-3 mb-3">
          <MapGoogle
            coordonnees={localisationFilter}
            setCountrySelected={setLocalisationSelected}
          />
          <InfosTiersLieu />
        </div>
      )}
      {showUsagesDigitaux && (
        <div className="d-flex  flex-nowrap border-bottom pb-3 mb-3 containerFiltresSecondeNiveau">
          <span
            onClick={(e) => setUsageDigitalSelected([])}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleBlankLine size="1.5em" role="button" className="text-danger" />
          </span>
          <span
            onClick={(e) => setUsageDigitalSelected(usageDigitalFilter)}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleLine size="1.5em" role="button" className=" text-danger" />
          </span>
          {usageDigitalFilter.map((usage, index) => (
            <div key={usage.tag} className="m-1 p-1 border align-items-center d-flex">
              <Form.Check
                id={usage.tag}
                name={usage.tag}
                type="checkbox"
                label={t("commun.usagesDigital." + usage.tag)}
                value={usage.tag}
                checked={
                  usageDigitalSelected.filter((item) => item === usage).length ? "checked" : ""
                }
                onChange={(e) => toggleUsageDigitaux(e.target)}
              />
            </div>
          ))}
        </div>
      )}
      {showUsages && (
        <div className="d-flex  flex-nowrap border-bottom pb-3 mb-3 containerFiltresSecondeNiveau">
          <span
            onClick={(e) => setUsageSelected([])}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleBlankLine size="1.5em" role="button" className="text-danger" />
          </span>
          <span
            onClick={(e) => setUsageSelected(usageFilter)}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleLine size="1.5em" role="button" className=" text-danger" />
          </span>
          {usageFilter.map((usageSalle, index) => (
            <div
              key={"checkUsagesSalle_" + index}
              className="m-1 p-1 border align-items-center d-flex"
            >
              <Form.Check
                id={"usages-" + index}
                type="checkbox"
                label={usageSalle.nom}
                value={usageSalle._id}
                checked={
                  usageSelected.filter((item) => item._id === usageSalle._id).length
                    ? "checked"
                    : ""
                }
                onChange={(e) => toggleUsage(e.target)}
              />
            </div>
          ))}
        </div>
      )}

      {showCapacity && (
        <div className="d-flex  flex-nowrap border-bottom pb-3 mb-3 containerFiltresSecondeNiveau">
          <span
            onClick={(e) => setCapacitySelected([])}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleBlankLine size="1.5em" role="button" className="text-danger" />
          </span>
          <span
            onClick={(e) => setCapacitySelected(capacityFilter)}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleLine size="1.5em" role="button" className=" text-danger" />
          </span>
          {capacityFilter.map((capacity, index) => (
            <div key={"capacite_" + index} className="m-1 p-1 border align-items-center d-flex">
              <Form.Check
                id={"capacite_" + index}
                name={"capacite_" + index}
                type="checkbox"
                label={t("public.pageTierslieux.critere_" + capacity)}
                value={capacity}
                checked={
                  capacitySelected.filter((item) => item === capacity).length ? "checked" : ""
                }
                onChange={(e) => toggleCapacity(e.target)}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlocFiltresEspaces;
